import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";
import CheckCSName from "../CheckCSName";

export function B28({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.OP04.error_id: {
            const profiles = Array.from(new Set(row.data.map(x => x.profile)))

            return (
                <>
                    <ResultText>
                        There are negative water surface slopes DS of the following {row?.data?.length} cross sections for the listed profiles. The drawdowns and drawdown slopes are noted as well. Drawdowns equal to or higher than the threshold value of {settings?.thresholds?.drawdown_default} ft are highlighted in red text.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>Cross Section</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>Profiles</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left', verticalAlign: 'top', width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'left', width: HecRasHelper.getWidth(40)}}>
                                            {
                                                r.profiles?.map(x => {
                                                        const color = Math.abs(x?.drawdown) >= settings?.thresholds?.drawdown_default ? 'red' : ''
                                                        return (
                                                            <ResultText>
                                                                {x?.profile} ({<span style={{color}}>{x?.drawdown}</span>} ft, {x?.drawdown_slope})
                                                            </ResultText>
                                                        )
                                                    })
                                            }
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}